import { render } from "./Cookies_old.vue?vue&type=template&id=aca75ffe&scoped=true"
import script from "./Cookies_old.vue?vue&type=script&lang=js"
export * from "./Cookies_old.vue?vue&type=script&lang=js"

import "./Cookies_old.vue?vue&type=style&index=0&id=aca75ffe&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1366294755/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca75ffe"]])

export default __exports__